<script lang="ts">
    import Fa from 'svelte-fa'
    import { faAngleLeft, faFileExport } from '@fortawesome/free-solid-svg-icons'
    import { createEventDispatcher, onMount } from 'svelte/internal'
    import { Audience } from '../../modules/eventsApi/audiences/audience'
    import { AudiencesRepository } from '../../modules/eventsApi/audiences/audiences.repository'
    import { AudiencesService } from '../../modules/eventsApi/audiences/audiences.service'
    import Content from '../_common/content.svelte'
    import dayjs from 'dayjs'
    import 'dayjs/locale/pt-br'
    import { AutomationsRepository } from '../../modules/automationApi/automations/automation.repository'
    import { AutomationsService } from '../../modules/automationApi/automations/automation.service'
    import { AutomationGroupsRepository } from '../../modules/automationApi/automation-groups/automation-groups.repository'
    import { AutomationGroupsService } from '../../modules/automationApi/automation-groups/automation-groups.service'
    import { AutomationGroup } from '../../modules/automationApi/automation-groups/automation-group'
    import type { Person } from '../../modules/eventsApi/persons/person'
    import { PersonsRepository } from '../../modules/eventsApi/persons/persons.repository'
    import { PersonsService } from '../../modules/eventsApi/persons/persons.service'
    dayjs.locale('pt-br')

    const dispatch = createEventDispatcher()

    const rep = new AutomationGroupsRepository()
    const service = new AutomationGroupsService(rep)
    let personsR = new PersonsRepository()
    let personsS = new PersonsService(personsR)

    export let automationGroupId: string = null
    let entity: AutomationGroup = new AutomationGroup()
    entity.automation = []

    async function loadEntities(id) {
        entity = await service.getOne(id, { rules: true, persons: true })
        let personsId = []
        for (const automation of entity.automation) {
            for (const contacted of automation.contacted) {
                if (!personsId.includes(contacted.personId)) {
                    personsId.push(contacted.personId)
                }
            }
        }
        let persons: Person[] = []
        let promises = []
        for (let i = 0; i < personsId.length; i += 100) {
            const chunk = personsId.slice(i, i + 100)
            promises.push(personsS.getAll({ persons: chunk.join(','), removed: true }))
        }
        const results = await Promise.all(promises)
        for (const result of results) {
            persons = persons.concat(result)
        }
        for (let automation of entity.automation) {
            for (let contacted of automation.contacted) {
                contacted.person = persons.find((el) => el.personId === contacted.personId)
            }
        }
        entity = entity
        console.log('automations', entity)
    }

    onMount(async () => {
        await loadEntities(automationGroupId)
    })

    function evaluateError(error) {
        window.error(error)
    }

    function goBack() {
        dispatch('close')
    }

    function download(filename, text) {
        var pom = document.createElement('a')
        pom.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(text))
        pom.setAttribute('download', filename)

        if (document.createEvent) {
            var event = document.createEvent('MouseEvents')
            event.initEvent('click', true, true)
            pom.dispatchEvent(event)
        } else {
            pom.click()
        }
    }
    function exportPersons() {
        let csv = 'Nome,Telefone,E-Mail,Nascimento,Cadastro\n'

        for (const a of entity.automation) {
            for (const p of a.contacted) {
                csv +=
                    p.person.name.replaceAll(',', ' ').replaceAll('"', ' ') +
                    ',' +
                    (p.person.phone || '') +
                    ',' +
                    (p.person.email || '') +
                    ',' +
                    (!!p.person.born ? dayjs(p.person.born).locale('pt-br').format('DD/MM/YYYY') : '') +
                    ',' +
                    dayjs(p.person.createdAt).format('DD/MM/YYYY') +
                    '\n'
            }
        }
        download(entity.label + '.csv', csv)
    }
</script>

<Content>
    <div class="grid-act">
        <button class="btn btn-secondary" on:click={goBack}><Fa icon={faAngleLeft} /> Voltar</button>
        <div class="spacer" />
        <!-- <button class="btn btn-secondary" on:click={exportPersons}><Fa icon={faFileExport} /> Exportar</button> -->
    </div>
    <div class="grid-head px-2">
        <div class="row">
            <div class="col">Nome</div>
            <div class="col-2">Telefone</div>
            <div class="col">E-Mail</div>
            <div class="col-2">Data</div>
            <div class="col-1">Status</div>
        </div>
    </div>
    <div class="grid-body px-2">
        {#each entity.automation as automation}
            {#each automation.contacted as p}
                <div class="row line liner py-1">
                    <div class="col nowrap">{p.person?.name || '-'}</div>
                    <div class="col-2">{p.person?.phone || '-'}</div>
                    <div class="col nowrap">{p.person?.email || '-'}</div>
                    <div class="col-2">{dayjs(p.createdAt).format('DD/MM/YYYY HH:mm:ss')}</div>
                    <div class="col-1">{p.status}</div>
                    <!-- todo: adicionar botão para acompanhar o desenrolar da automação. ex.: se foi para o broker, buscar informações. se foi para o pipe, buscar informações. -->
                </div>
            {/each}
        {/each}
    </div>
</Content>

<style></style>
